<template>
	<div>
		<q-uploader
            ref="qUploader"
            :multiple="multiple"
            :hide-upload-btn="hideUploadBtn"
            :send-raw="sendRaw"
            :label="label"
            :accept="accept"
            :auto-upload="autoUpload"
            :max-file-size="maxFileSize"
            :no-content-type="noContentType"
            :color="color"
            :files="files"
            @added="$emit('added', $event)"
						@removed="$emit('removed', $event)"
        >
          <template v-slot:header="scope">
            <div class="row no-wrap items-center q-pa-sm q-gutter-xs">
              <q-btn v-if="scope.queuedFiles.length > 0" icon="clear_all" @click="scope.removeQueuedFiles" round
                     dense
                     flat/>
              <q-btn v-if="scope.uploadedFiles.length > 0" icon="done_all" @click="scope.removeUploadedFiles" round
                     dense flat/>
              <q-spinner v-if="scope.isUploading" class="q-uploader__spinner"/>
              <div class="col">
                <div class="q-uploader__title">{{ label }}</div>
              </div>
              <q-btn v-if="scope.canAddFiles" type="a" icon="add_box" round dense flat>
                <q-uploader-add-trigger/>
              </q-btn>

              <q-btn v-if="scope.isUploading" icon="clear" @click="scope.abort" round dense flat>
                <q-tooltip>Abort Upload</q-tooltip>
              </q-btn>
            </div>
          </template>

        </q-uploader>
		<p v-if="error.length" class="text-negative q-mt-sm q-field__bottom">
			{{error}}
		</p>
	</div>
</template>

<script>

  let readBlobAsDataUrl = function(blob, cb) {
      let a = new FileReader()
      a.onload = function(e) {
          cb(e.target.result)
      };
      a.readAsDataURL(blob)
  };

  export default {
    name: 'FileUploader',
    props: {
      label: {
        type: String,
        default: ''
      },
      autoUpload: {
        type: Boolean,
        default: false
      },
      hideUploadBtn: {
        type: Boolean,
        default: false
      },
      sendRaw: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      noContentType: {
        type: Boolean,
        default: false
      },
      manner: {
        type: String,
        default: ''
      },
      maxFileSize: {
        type: Number,
        default: 5120*1024
      },
      accept: {
        type: String,
        default: 'image/*'
      },
      files: {
        type: Array|String,
        default: () => { [] }
      },
      color: {
        type: String,
        default: 'ok-btn'
      },
      error: {
        type: String,
        default: ''
      }
    },
    methods: {
      blobToFile(blob, imgSrc, imageObj) {
        let file = new File([blob], imageObj.name,
            {
              id: imageObj.id,
              size: blob.size,
              type: blob.type,
              name: imageObj.name,
              __img: {
                  src: imgSrc
              }
            })
          file.id = imageObj.id
          this.$refs.qUploader.addFiles([file])
      },
      addFiles(files) {
          files.forEach( image => {
        fetch(image.full_url)
        .then((res) => {
            return res.blob();
        })
        .then((blob) => {
            readBlobAsDataUrl(blob, (imgSrc) => {
                this.blobToFile(blob, imgSrc, image)
            })
        })
          });
    },
    },
    mounted() {
        this.addFiles(this.files)
    }
  }
</script>
